/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import {
	isRejected,
	isRejectedWithValue,
	Middleware,
	MiddlewareAPI
} from '@reduxjs/toolkit';
import { sendNotification } from '../Alerts/alertSlice';
import { NotificationProps } from '../Layout/Alerts/Notification';

const excludedEndpoints: string[] = ['login'];

export const ErrorNotificationMiddleware: Middleware =
	(api: MiddlewareAPI) => (next) => (action) => {
		/**
		 * TODO:
		 * This middleware type is apparently an issue in the current state of RTK and it's add on packages. For now, getting ugly and disabling all these linting errors
		 * so I can move on with converting to vite and getting this redeployed. Will circle back to correctly fix.
		 * https://redux-toolkit.js.org/usage/migrating-rtk-2#middleware-type-changed---middleware-action-and-next-are-typed-as-unknown
		 */
		if (
			(action as { meta?: { arg?: { endpointName?: string } } }).meta?.arg
				?.endpointName &&
			excludedEndpoints.includes(
				(action as { meta: { arg: { endpointName: string } } }).meta.arg
					.endpointName
			)
		) {
			return next(action);
		}

		if (isRejectedWithValue(action)) {
			console.log(action);
			const error: Omit<NotificationProps, 'uniqueId'> = {
				intent: 'error',
				appearance: 'inverted',
				message: isBadRequest(action)
					? extractBadRequestMessage(action)
					: `An error occurred with the ${
							(action.meta.arg as { endpointName: string })
								.endpointName
					  } API.` //action.error.data.message
			};
			api.dispatch(sendNotification(error));
		} else if (isRejected(action)) {
			console.log(action);
			api.dispatch(
				sendNotification({
					appearance: 'inverted',
					intent: 'error',
					message: isBadRequest(action)
						? extractBadRequestMessage(action)
						: `An error occurred with the ${
								(action.meta.arg as { endpointName: string })
									.endpointName
						  } API.`
				})
			);
		}

		return next(action);
	};

function isBadRequest(action: any) {
	console.log(action?.payload?.data?.status);
	if (action?.payload?.data?.status === 400) {
		return true;
	}
	return false;
}

function extractBadRequestMessage(action: any) {
	const errors = action?.payload?.data?.errors;
	const errorMessages: string[] = [];

	for (const prop in errors) {
		if (Object.prototype.hasOwnProperty.call(errors, prop)) {
			errorMessages.push(errors[prop]);
		}
	}

	return errorMessages.join();
}
